import { Box } from '@mui/material'
import ReactQuill from 'react-quill-new'

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
}

const quillSx = (height: string) => ({
  '& .ql-toolbar': {
    borderRadius: '4px 4px 0 0',
    borderColor: '#ccc',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: 'background.paper',
    padding: '4px 8px',
  },
  '& .ql-toolbar.ql-snow button': {
    width: '24px',
    height: '24px',
    padding: '2px',
  },
  '& .ql-toolbar.ql-snow button svg': {
    width: '16px',
    height: '16px',
  },
  '& .ql-color-picker': {
    width: '28px !important',
    height: '24px',
    padding: '0 !important',
    border: 'none !important',
    backgroundColor: 'transparent !important',
  },
  '& .ql-color-picker .ql-picker-label': {
    padding: '2px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .ql-color-picker .ql-picker-label svg': {
    width: '16px !important',
    height: '16px !important',
  },
  '& .ql-container.ql-snow': {
    borderTop: 'none',
    borderRadius: '0 0 4px 4px',
    height,
  },
  '& .ql-toolbar.ql-snow .ql-picker-options': {
    borderRadius: '4px',
  },
  '& .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options': {
    border: 'none !important',
    ml: '-9px',
    mt: '1px',
  },
  '& .ql-snow .ql-picker.ql-header': {
    width: '120px',
    borderRadius: '4px',
  },
  '& .ql-picker': {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '1px 6px',
    minHeight: '26px',
    fontSize: '0.8rem',
    backgroundColor: 'white',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  '& .ql-picker-label': {
    padding: 0,
    minHeight: 'unset',
    fontSize: '0.8rem',
    color: 'rgba(0,0,0,0.87)',
    display: 'flex',
    alignItems: 'center',
  },
  '& .ql-picker-options': {
    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
    border: '1px solid #ccc',
    backgroundColor: 'white',
    zIndex: 10,
  },
  '& .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label': {
    border: 'none',
  },
})

export function RichTextEditor({
  value,
  onChange,
  height = '200px',
  placeholder,
}: {
  value?: ReactQuill.Value | undefined
  onChange?: (value: string) => void
  height?: string
  placeholder?: string
}) {
  return (
    <Box sx={quillSx(height)}>
      <ReactQuill
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
      />
    </Box>
  )
}
